import React, { useRef, useState } from "react";
import { AiFillEye, AiFillEyeInvisible, AiOutlineMinus } from "react-icons/ai";
import { BsFillInfoCircleFill } from "react-icons/bs";

// function isHTML(str) {
//   var doc = new DOMParser().parseFromString(str, "text/html");
//   return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
// }

const InputTag = ({
  label,
  length,
  name,
  defaultValue,
  type,
  multiple,
  required,
  disabled,
  info,
  pattern,
  warning,
}) => {
  const [visibility, setVisibility] = useState(true);
  const [inputType, setInputType] = useState(type);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const inputRef = useRef();
  // let newRR = defaultValue;

  const handleDelete = () => {
    setVisibility(false);
  };

  // function togglePassword(newType) {
  //   setPasswordVisibility((old) => !old);
  //   // const oldValue = inputRef.current.value;
  //   // if (type === "password") {
  //   //   setPasswordVisibility((old) => !old);
  //   //   setInputType(newType);
  //   //   newRR = "dummy";
  //   //   // inputRef.current.value = "oldValue";
  //   // }
  // }
  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-end w-full" : "hidden"}
    >
      <div className="w-full">
        <label htmlFor={name} className="label capitalize">
          <span className="text-md font-semibold text-darkPrimary dark:text-darkWhite">
            {multiple && length ? label + " " + length : label}
          </span>
          {required && <span className="text-red-500 text-lg">*</span>}
        </label>
        {info && (
          <span className="relative z-50 group">
            <BsFillInfoCircleFill className="inline ml-2 mb-1 text-gray-700 dark:text-darkWhite text-sm cursor-pointer" />
            <span className="bg-white group-hover:block hidden text-gray-700 font-medium dark:bg-gray-700 dark:text-darkWhite rounded-md left-0 absolute w-fit whitespace-nowrap shadow p-3">
              {info}
            </span>
          </span>
        )}
        <div className="relative">
          <input
            name={visibility ? name : ""}
            defaultValue={defaultValue}
            type={inputType}
            className="w-full my-2 darkPrimary border border-gray-300 rounded-md px-3 py-2.5 z-0 bg-transparent outline-none dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:hover:border-gray-300 disabled:dark:bg-gray-950 disabled:dark:text-gray-500 dark:text-darkWhite"
            required={required}
            disabled={disabled}
            id={name}
            ref={inputRef}
            pattern={pattern ? pattern : null}
            autoComplete="off"
          />
          {/* password show container */}
          {/* {type === "password" && passwordVisibility && (
            <span className="absolute left-0.5 top-2.5 bottom-2.5 bg-gray-50 flex items-center rounded-l-md">
              <span className="px-2.5">password</span>
            </span>
          )} */}
          {/* {type === "password" && (
            <>
              {!passwordVisibility ? (
                <button
                  type="button"
                  onClick={() => togglePassword("text")}
                  className="absolute right-4 top-5"
                >
                  <AiFillEye className="text-xl text-gray-500" />
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() => togglePassword("password")}
                  className="absolute right-4 top-5"
                >
                  <AiFillEyeInvisible className="text-xl text-gray-500" />
                </button>
              )}
            </>
          )} */}
        </div>
      </div>
      <div className={!multiple ? "hidden" : ""}>
        <button
          type="button"
          onClick={handleDelete}
          className="btn btn-sm btn-circle hover:bg-gray-50 border border-gray-400 mb-2 p-2 rounded-full"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default InputTag;
